// extracted by mini-css-extract-plugin
module.exports = {"note":"Notes_note__60lge","date":"Notes_date__Sjgnu","noteTitle":"Notes_noteTitle__GuWgm"};